import { faPaintBrush, faUpload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Group, Radio, Stack, Text, Title } from '@mantine/core'
import React, { SetStateAction } from 'react'
import { AdDesignPrice, AdSelectionTypes, COLORS } from '../../utils/constants'
import classes from '../css/AdTypeSelector.module.css'

interface AdTypeSelectorProps {
  setAdSelectionType: React.Dispatch<SetStateAction<AdSelectionTypes>>
  adSelectionType: AdSelectionTypes
  requiresApproval: boolean
  isMobile?: boolean
}

export function AdTypeSelector(props: AdTypeSelectorProps) {
  const { adSelectionType, setAdSelectionType, requiresApproval, isMobile } =
    props
  return (
    <Radio.Group
      value={adSelectionType.toString()}
      onChange={(val) => setAdSelectionType(val as AdSelectionTypes)}
    >
      <Stack pt={isMobile ? 20 : 50} gap={isMobile ? 'md' : 'xl'}>
        <Radio.Card
          className={classes.root}
          radius='md'
          value={AdSelectionTypes.UploadAd.toString()}
          key={AdSelectionTypes.UploadAd.toString()}
          p={isMobile ? 20 : 40}
        >
          <Group wrap='nowrap' gap={isMobile ? 15 : 30}>
            <FontAwesomeIcon
              icon={faUpload}
              size={isMobile ? 'lg' : 'xl'}
              color={
                adSelectionType === AdSelectionTypes.UploadAd
                  ? COLORS.HiddenGemzRed
                  : 'default'
              }
            />
            <Box>
              <Text fw={700} fz={isMobile ? 18 : 24}>
                Upload Your Own Ad
              </Text>
              <Text mt={8} fz={isMobile ? 12 : 14}>
                Design an ad yourself and upload it.
                {requiresApproval &&
                  ' After submitting your ad, the host will need to approve the content'}
              </Text>
            </Box>
          </Group>
        </Radio.Card>

        {/* <Radio.Card
          className={classes.root}
          radius="md"
          value={AdSelectionTypes.SelectExistingAd.toString()}
          key={AdSelectionTypes.SelectExistingAd.toString()}
          pt={20}
          pb={20}
          pl={30}
          pr={30}
        >
          <Group wrap="nowrap" gap={30}>
            <FontAwesomeIcon
              icon={faRectangleList}
              size="xl"
              color={
                adSelectionType === AdSelectionTypes.SelectExistingAd
                  ? COLORS.HiddenGemzRed
                  : 'default'
              }
            />
            <Box>
              <Text fw={700} fz={24}>
                Select Existing Ad
              </Text>
              <Text mt={8} fz={14}>
                Select from the ads that you uploaded previously.
                {requiresApproval &&
                  ' If your ad was approved for this device in the past, it can run automatically'}
              </Text>
            </Box>
          </Group>
        </Radio.Card> */}
        <Radio.Card
          className={classes.root}
          radius='md'
          value={AdSelectionTypes.PayForDesign.toString()}
          key={AdSelectionTypes.PayForDesign.toString()}
          p={isMobile ? 20 : 40}
        >
          <Group justify='space-between' wrap='nowrap'>
            <Group wrap='nowrap' gap={isMobile ? 15 : 30}>
              <FontAwesomeIcon
                icon={faPaintBrush}
                size={isMobile ? 'lg' : 'xl'}
                color={
                  adSelectionType === AdSelectionTypes.PayForDesign
                    ? COLORS.HiddenGemzRed
                    : 'default'
                }
              />
              <Box>
                <Text fw={700} fz={isMobile ? 18 : 24}>
                  Let us design it
                </Text>
                <Text mt={8} fz={isMobile ? 12 : 14}>
                  Work with our team of experienced designers to create an ad
                  tailored to fit your needs
                </Text>
              </Box>
            </Group>
            <Title size={isMobile ? 'h4' : 'h3'}>+${AdDesignPrice}</Title>
          </Group>
        </Radio.Card>
      </Stack>
    </Radio.Group>
  )
}
